import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { MenuItems } from '../../types/MenuItems';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/dashboard/dashboard_page_1.webp';
import image2 from '../../assets/images/dashboard/dashboard_page_2.webp';
import image3 from '../../assets/images/dashboard/dashboard_page_3.webp';
import image4 from '../../assets/images/dashboard/dashboard_page_4.webp';
import image5 from '../../assets/images/dashboard/dashboard_page_5.webp';

import './Dashboard.scss';

const images = [image1, image2, image3, image4, image5];

export const Dashboard = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.DASHBOARD}
        title={t.DASHBOARD.title}
        itemsList={t.DASHBOARD.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.DASHBOARD}-page-${i + 1}`,
        }))}
      />

      {t.DASHBOARD.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.DASHBOARD}-page-${i + 1}`}
          color={style.getPropertyValue('--turquoise')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
